export function normalizeName(name: string): string {
  return name
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add a space between lowercase and uppercase letters
    .replace(/_/g, ' ') // Replace underscores with spaces (optional, in case of snake_case)
    .trim(); // Remove leading and trailing spaces, if any
}
